<template>
  <transition name="fade">
    <div v-if="visible" class="popup-overlay" @click.self="close">
      <div class="popup-newsletter">
        <button class="close" @click="close">×</button>

        <h2>🌬️ Faça parte da Terra do Vento</h2>
        <p>
          Um espaço para compartilhar histórias, novidades e experiências que
          conectam vento, mar e pessoas
        </p>

        <form @submit.prevent="submit">
          <input
            type="email"
            v-model="email"
            placeholder="Seu melhor e-mail"
            required
          />

          <button type="submit" :disabled="loading">
            {{ loading ? "Enviando..." : "Quero fazer parte" }}
          </button>

          <p v-if="sucesso" class="success">
            {{ getSuccess(sucesso) }}
          </p>

          <p v-if="error" class="error">
            {{ getError(error) }}
          </p>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
import { api } from "@/services/services";

export default {
  name: "NewsletterPopup",

  data() {
    return {
      visible: false,
      email: "",
      sucesso: "",
      error: "",
      loading: false,
    };
  },

  mounted() {
    if (!localStorage.getItem("newsletter_popup_seen")) {
      document.addEventListener("mouseleave", this.handleExitIntent);
    }
  },

  beforeDestroy() {
    document.removeEventListener("mouseleave", this.handleExitIntent);
  },

  methods: {
    handleExitIntent(event) {
      if (event.clientY <= 0) {
        this.show();
        document.removeEventListener("mouseleave", this.handleExitIntent);
      }
    },

    show() {
      this.visible = true;
      localStorage.setItem("newsletter_popup_seen", "true");
    },

    close() {
      this.visible = false;
    },

    async submit() {
      this.sucesso = "";
      this.error = "";
      this.loading = true;

      const formData = new FormData();
      formData.append("email", this.email);

      try {
        const response = await api.post("newsletter/assinar", formData);

        if (response.data.error) {
          this.error = response.data.error;
        } else {
          this.sucesso = response.data;
          this.email = "";

          // fecha popup após sucesso
          setTimeout(this.close, 2000);
        }
      } catch (erro) {
        if (erro.response?.data?.error) {
          this.error = erro.response.data;
        } else {
          this.error = {
            error: "Erro ao enviar. Tente novamente.",
            error_en: "Error sending. Please try again.",
          };
        }
      } finally {
        this.loading = false;
      }
    },

    getSuccess(msg) {
      if (!msg) return "";
      return this.$i18n.locale === "en" ? msg.message_en : msg.message;
    },

    getError(msg) {
      if (!msg) return "";
      return this.$i18n.locale === "en" ? msg.error_en : msg.error;
    },
  },
};
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 2147483647; /* valor seguro máximo */
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup-newsletter {
  background: #0c223a;
  padding: 4rem;
  width: 620px;
  max-width: 90vw;
  border-radius: 8px;
  position: relative;
  z-index: 1; /* nem precisa ser alto */
}

.popup-newsletter h2 {
  font-size: 32px;
  margin-bottom: 0.5rem;
  color: #fff;
  font-family: "Nunito", sans-serif !important;
  font-weight: 700;
  line-height: 48px;
}

.popup-newsletter p {
  margin-bottom: 18px;
  color: #cfdbe9;
  line-height: 32px;
}

.popup-newsletter input {
  width: 100%;
  padding: 0.75rem;
  margin-bottom: 1rem;
  border-radius: 6px;
}

.popup-newsletter button[type="submit"] {
  width: 100%;
  padding: 0.75rem;
  background: #5782ae;
  color: #dcedff;
  border: none;
  cursor: pointer;
  font-size: 18px;
  text-transform: uppercase;
  font-weight: 700;
  border-radius: 6px;
}

.popup-newsletter button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.success {
  margin-top: 12px;
  color: #9ad0ff;
}

.error {
  margin-top: 12px;
  color: #ffb4b4;
}

.close {
  position: absolute;
  top: 10px;
  right: 12px;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #fff;
}

/* animação */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
